<template lang="pug">
    .tab-content
        z-select(
            label="Заявитель"
            v-model="who"
            :required="true"
            name="applicant_who"
            id="applicant_who"
            v-validate="'required'"
            v-bind:error="errors.first('applicant_who')"
            data-vv-name="applicant_who"
            v-bind:data-vv-as="' '"
            v-bind:disabled="$props.block"
            inline
            v-bind:dirty.sync="dirtyObj.type"
        )
            option(v-bind:value="$props.deal.sender_id"   ) Отправитель
            option(v-bind:value="$props.deal.recipient_id") Получатель
            option(v-bind:value="$props.deal.payer_id" v-if="parseInt($props.deal.payer_id)  !== parseInt($props.deal.sender_id) && parseInt($props.deal.payer_id) !== parseInt($props.deal.recipient_id)") Плательщик
</template>
<script>
    import autocomplete from '@/components/autocomplete'
    import moment from "moment"
    import Properties from '@/components/Properties'
    import WacomSignature from '@/components/WacomSignature';
    import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
    export default {
        name: 'payer',
        props: {
            value: {
                type: [String, Number],
                default: () => {
                    return null
                }
            },
            deal: {
                type: Object,
                default: () => {
                    return {id: null}
                }
            },
            block: {
                type: Boolean,
                default: false
            },
            dirty: {
                type: Boolean,
                default: false
            }
        },
        components: {
            Properties,
            autocomplete,
            WacomSignature,
            ZInput, ZSelect
        },
        data() {
            return {
                parent: null,
                who: null,
                dirtyObj: {
                    type: false
                }
            }
        },
        computed: {
            isDirty() {
                return !!Object.values(this.dirtyObj).find(item => item);
            }
        },
        watch: {
            '$props.value'(value) {
                this.init();
            },
            'who'(who) {
                this.$emit('change', who);
                this.$emit('input', who);
            },
            '$props.deal.sender_id': {
                deep: true,
                handler(senderId) {
                    if (senderId == 'new') return;
                    if (senderId && (!this.who || this.who == 'new')) this.who = senderId;
                }
            },
            'isDirty'(val) {
                if (val) this.emitDirty();
            }
        },
        methods: {
            emitDirty() {
                this.$emit('update:dirty', this.isDirty);
            },
            init() {
                this.validateClear();
                if (this.$props.deal && (!this.who || this.who == 'new')) {
                    if (this.$props.deal.applicant_id      && this.$props.deal.applicant_id != 'new') this.who = this.$props.deal.applicant_id;
                    else if (this.$props.deal.sender_id    && this.$props.deal.sender_id    != 'new') this.who = this.$props.deal.sender_id;
                    else if (this.$props.deal.recipient_id && this.$props.deal.recipient_id != 'new') this.who = this.$props.deal.recipient_id;
                }
            },
            validateClear() {
                this.errors.clear();
                this.$validator.errors.clear();
                this.$validator.reset();
            },
            validate() {
                return this.$validator.validateAll();
            }
        },
        created() {
            this.$nextTick(() => this.init());
        },
    }
</script>



// WEBPACK FOOTER //
// Applicant.vue?42f7f6e0